import React from "react";

// Background + Member Images
import bgTeam from "../../../images/bg/7.png";
import noiseBg from "../../../images/team/noice-bg.png";

import img01 from "../../../images/team/img01.jpg";
import img02 from "../../../images/team/img02.jpg";

const teamMembers = [
  {
    name: "Avinash Sharma",
    role: "Founder & CEO",
    img: img01,
  },
  {
    name: "Jyotsana Sharma",
    role: "Co-Founder",
    img: img02,
  },
  // {
  //   name: "Krishan Kumar",
  //   role: "Operations Head",
  //   img: img03,
  // },
  // {
  //   name: "Brijesh Dubey",
  //   role: "Technical Director",
  //   img: img04,
  // },
  // {
  //   name: "Raghvendra Dwivedi",
  //   role: "Technical Head",
  //   img: img05,
  // },
];

const TeamSection: React.FC = () => {
  return (
    <section
      className="team pt-140 pb-150 bg_img"
      style={{ backgroundImage: `url(${bgTeam})` }}
    >
      <div className="container">
        <div className="sec-title sec-title-center text-center mb-45">
          <span className="sub-title mb-20">Our Experts</span>

          <h2 className="title title-line_height">Our Experts</h2>

          <p className="content">
            Our Company is supported by a team of 40+ members in number, working
            day and night delivering the most scalable, practical yet most
            advanced softwares and services around the globe.
          </p>
        </div>

        <div className="row mt-none-55 justify-content-center">
          {teamMembers.map((member, i) => (
            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12 mt-55" key={i}>
              <div className="xb-team-item xb-border">
                {/* <div className="xb-item--img">
                  <img src={member.img} alt={member.name} />
                </div> */}

                <div className="xb-item--holder ul_li_between">
                  <div className="xb-item--author">
                    <h2 className="xb-item--name">{member.name}</h2>
                    <span className="xb-item--desig">{member.role}</span>
                  </div>
                  {/* <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="xb-item--social xb-border">
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a> */}
                </div>

                <div className="xb-bg">
                  <img src={noiseBg} alt="background texture" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
